import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { apiVariable } from "../../../api/apiVariable";
import axios from "axios";
import useAuth from "../../../hooks/useAuth";
import { useState } from "react";
import GenericFormPopup from "../GenericFormPopup/GenericFormPopup";
import { Button } from "@mui/material";
import { useParams } from "react-router-dom";
import StatusSnackbar from "../../General/StatusSnackbar/StatusSnackbar";
import { getId } from "../../HR/UpdateEmployeePopup/UpdateEmployeePopup";

const AssignDriverButton = () => {
  const { token } = useAuth();
  const [driverData, setDriverData] = useState<any[]>([]);
  const [open, setOpen] = useState(false);
  const [status, setStatus] = useState<"idle" | "success" | "error">("idle");
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const truckId = useParams().id;
  const queryClient = useQueryClient();

  useQuery({
    queryKey: ["allDrivers"],
    queryFn: async () => {
      const res = await axios.get(`${apiVariable}/getAllDrivers`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: { areActive: true },
      });
      const formattedData = res.data.map((driver: any) => ({
        label: `${driver.firstName} ${driver.lastName} | ${driver.phoneNumber}`,
        id: driver.id,
      }));
      setDriverData(formattedData);
      return res.data;
    },
    enabled: open,
  });

  const mutation = useMutation({
    mutationFn: (data: any) =>
      axios.post(`${apiVariable}/assignDriverToTruck`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    onSuccess: () => {
      setStatus("success");
      queryClient.invalidateQueries({ queryKey: ["assignedDrivers"] });
      handleClose();
    },
    onError: (error: any) => {
      setStatus("error");
      setErrorMessage(error.response.data || "Failed to submit truck");
    },
  });

  const submitHandler = (data: any) => {
    data.truckId = getId(truckId);
    data.driverId = getId(data.driverId);
    mutation.mutate(data);
  };

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleSnackbarClose = () => setStatus("idle");

  return (
    <>
      <Button
        variant="contained"
        color="primary"
        onClick={handleOpen}
        sx={{
          mr: 2,
        }}
      >
        Assign driver
      </Button>
      <GenericFormPopup
        formFields={[
          {
            name: "driverId",
            label: "Driver",
            type: "combo",
            dataKey: "drivers",
          },
        ]}
        initialValues={{ driverId: "", truckId: "" }}
        title="Assign Driver to Truck"
        onSubmit={submitHandler}
        open={open}
        onClose={handleClose}
        autocompleteData={{ drivers: driverData }}
        loading={mutation.isPending}
      />
      <StatusSnackbar
        status={status}
        successMessage="Driver assigned successfully!"
        errorMessage={errorMessage}
        handleClose={handleSnackbarClose}
      />
    </>
  );
};

export default AssignDriverButton;
